module.exports = __webpack_public_path__ + "media/target_area_icon/dept_management-ea77b4db.png";